import * as Yup from 'yup';

const RENEW_MEMBER_FILE_CARD_SCHEMA = Yup.object().shape({
	member_type: Yup.string().required('Member Type is required'),
	card_on_file: Yup.object()
		.shape({
			id: Yup.string(),
			billing_address: Yup.object().shape({
				postal_code: Yup.string()
			})
		})
		.nullable()
		.required('Card On File is required')
});

export default RENEW_MEMBER_FILE_CARD_SCHEMA;
